import type { VisualizationProps } from './types';

/**
 * LivingRoomSVG — гостиная: TV-консоль (низкий шкаф под телевизор + столешница).
 * Зоны: facade, corpus, handles, countertop. Без hooks. Конвенции — `./types.ts`.
 */
export function LivingRoomSVG({
  facadeColor,
  countertopColor,
  corpusColor,
  handlesColor,
}: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      {/* TV (decorative) */}
      <rect
        x="100"
        y="20"
        width="120"
        height="70"
        fill="#000000"
        stroke="#000000"
        strokeWidth="1"
        rx="3"
      />
      <rect x="105" y="25" width="110" height="60" fill="#444" rx="2" />
      <rect
        data-testid="zone-countertop"
        x="40"
        y="118"
        width="240"
        height="10"
        fill={countertopColor}
        stroke="#000000"
        strokeWidth="1"
      />
      <rect
        data-testid="zone-corpus"
        x="40"
        y="128"
        width="240"
        height="55"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="46"
        y="132"
        width="115"
        height="47"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="163"
        y="132"
        width="115"
        height="47"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="100"
        y="154"
        width="8"
        height="2"
        fill={handlesColor}
        rx="1"
      />
      <rect x="217" y="154" width="8" height="2" fill={handlesColor} rx="1" />
      <text
        x="100"
        y="172"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="32"
        y="155"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
      <text
        x="160"
        y="115"
        textAnchor="middle"
        fontSize="8"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        3
      </text>
    </svg>
  );
}
